import { z } from "zod";

export const createClanProfileSchema = z.object({
  description: z.string().min(1, "Описание клана обязательно"),
  image: z.instanceof(File),
});

export type CreateClanProfileSchema = z.infer<typeof createClanProfileSchema>;
